export default __webpack_public_path__ + "images/bunnings-logo-small.7ed7f59806527dea119414b47870921c.svg";